import ajax from '../../utils/ajax';

class ResetLoginResponse {
  /**
   * @param {boolean} isSuccess
   * @param {string} [message]
   */
  constructor(isSuccess, message) {
    this.isSuccess = isSuccess;
    this.message = message;
  }
}

/**
 * @param {string} emailAddress
 * @returns {Promise<ResetLoginResponse>}
 */
async function resetLogin(emailAddress) {
  try {
    await ajax.post('/api/loginreset', { Email: emailAddress });

    return new ResetLoginResponse(true);
  } catch (error) {
    // Endpoint returns a 400 on an invalid email address

    const { responseJSON } = error;

    if (responseJSON && responseJSON.message) {
      return new ResetLoginResponse(false, responseJSON.message);
    }

    return new ResetLoginResponse(false, 'There\'s been a system error. Please retry your request.');
  }
}

export default {
  resetLogin,
};



// WEBPACK FOOTER //
// ./src/account/login/ForgotPasswordService.js